import { requireAccess } from './permission'

export const fashion = [
  {
    path: '/fashion/noticias/:type?/:page?/:id?',
    name: 'FashionArticles',
    component: () => import('views/verticals/fashion/articles/Main'),
    title: 'Artigos',
    icon: 'fa-file-o',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    adminAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-fashion'
    }
  },
  {
    path: '/fashion/vouchers/:type?/:id?',
    name: 'FashionVouchers',
    component: () => import('views/verticals/fashion/vouchers/Main'),
    title: 'Vouchers',
    icon: 'fa-coupon-o',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    adminAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-fashion'
    }
  },
  // {
  //   path: '/fashion/temas/:type?/:page?/:id?',
  //   name: 'FashionThemes',
  //   component: () => import('views/verticals/fashion/themes/Main'),
  //   title: 'Temas',
  //   icon: 'fa-tags',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/fashion/autores/:type?/:page?/:id?',
  //   name: 'FashionAuthors',
  //   component: () => import('views/verticals/fashion/authors/Main'),
  //   title: 'Autores',
  //   icon: 'fa-pencil',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/fashion/versions/:type?/:page?/:id?',
  //   name: 'Versions',
  //   component: () => import('views/verticals/fashion/versions'),
  //   title: 'Versão dos aplicativos',
  //   icon: 'fa-tablet',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     // {
  //     //   title: 'Cadastrar',
  //     //   type: 'cadastrar',
  //     //   submenu: true
  //     // },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ],
  //   editorAccess: true,
  //   beforeEnter: requireAccess,
  //   meta: {
  //     permission: 'admin-fashion'
  //   }
  // },
  {
    path: '/fashion',
    component: () => import('views/verticals/fashion/articles/Main')
  }
]



// WEBPACK FOOTER //
// ./src/router/fashion.js